import { render, staticRenderFns } from "./CommentList.vue?vue&type=template&id=21123112&"
import script from "./CommentList.vue?vue&type=script&lang=ts&"
export * from "./CommentList.vue?vue&type=script&lang=ts&"
import style0 from "./CommentList.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports